<mat-form-field appearance="outline">
  <mat-date-range-input [rangePicker]="picker">
    <input matStartDate placeholder="Start date" [value]="selectedStartDate" (dateChange)="emitStartDate($event)">
    <input matEndDate placeholder="End date" [value]="selectedEndDate" (dateChange)="emitEndDate($event)">
  </mat-date-range-input>
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-date-range-picker #picker></mat-date-range-picker>
</mat-form-field>
